import axios from 'smg/axios';
import * as buttons from 'smg/buttons';
import { GetCountryIDFromPhone } from 'smg/countries';
import * as artwork from 'smg/customer-api/artwork';
import * as lineitems from 'smg/customer-api/lineitems';
import { GetPageRequestID } from 'smg/customer-api/pagerequests';
import * as promos from 'smg/customer-api/promos';
import * as quoterequests from 'smg/customer-api/quoterequests';
import { Session } from 'smg/customer-api/session';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import * as html from 'smg/html';
import { GetReadableSize } from 'smg/lineitemtypesizes';
import * as object from 'smg/object';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import * as uploads from 'smg/uploads';
import { GetFirstAndLast } from 'smg/users';
import { UUID } from 'smg/uuid';
import { Relref } from '../hugo';
declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

export default async function main() {
    const $stepTemplate = document.querySelector('#step-template') as HTMLTemplateElement;
    $stepTemplate.remove();

    const $optionTemplate = document.querySelector('#option-template') as HTMLTemplateElement;
    $optionTemplate.remove();

    const $stepOneContainer = template.Clone('#step-one-container') as HTMLElement;
    const $stepOneForm = $stepOneContainer.querySelector('#step-one-form') as HTMLFormElement;
    const $stepOneEmail = $stepOneForm.querySelector('#step-one-email') as HTMLInputElement;

    const $steps = document.querySelector('#steps') as HTMLElement;

    const $patchSizeTemplate = document.querySelector('#patches-size-form') as HTMLTemplateElement;
    $patchSizeTemplate.remove();

    const images = await artwork.GetArtworkByName({
        group: 'Quote',
        company: ['Signature Coins', 'Signature Pins', 'Signature Patches', 'Signature Lanyards'],
    });

    const $stepNumbers = document.querySelector('#step-numbers') as HTMLElement;
    const $summary = document.querySelector('#summary') as HTMLElement;
    document.querySelector('#visual-form-title-text')?.classList.remove('d-none');

    let currentStep: number = 0;

    const $form = document.querySelector('#contact-form') as HTMLFormElement;

    const showStep = () => {
        const $divs = $steps.children;
        Array.from($divs).forEach($ => $.classList.add('d-none'));
        $divs[currentStep]?.classList.remove('d-none');

        // have to declare these every time because they can change
        const $stepNumberElements = $stepNumbers.querySelectorAll('div');
        const $summaryElements = $summary.querySelectorAll('li');

        const $currentStepNumber = $stepNumberElements[currentStep];
        if (!$currentStepNumber.classList.contains('success')) {
            $currentStepNumber.classList.add('active');
            $currentStepNumber.addEventListener('click', () => {
                currentStep = Array.from($stepNumberElements).indexOf($currentStepNumber);
                showStep();
            });
        }

        const $currentSummary = $summaryElements[currentStep];
        if (!$currentSummary.classList.contains('success')) {
            $currentSummary.classList.add('active');
            $currentSummary.addEventListener('click', () => {
                currentStep = Array.from($summaryElements).indexOf($currentSummary);
                showStep();
            });
        }

        if (currentStep >= $steps.children.length) {
            $form.classList.remove('d-none');
        } else {
            $form.classList.add('d-none');
        }

        window.scrollTo(0, 0);
    };

    const next = () => {
        $stepNumbers.querySelectorAll('div')[currentStep].classList.add('success');
        $summary.querySelectorAll('li')[currentStep].classList.add('success');

        currentStep++;
        showStep();
    };

    const prev = () => {
        currentStep--;
        showStep();
    };

    const $email = $form.querySelector('#last-step-email') as HTMLInputElement;
    const $summaryEmail = document.querySelector('#summary-email') as HTMLElement;

    $stepOneEmail.addEventListener('input', () => {
        $email.value = $stepOneEmail.value;
        if ($summaryEmail.firstElementChild) {
            $summaryEmail.firstElementChild.textContent = $email.value;
        }
    });

    $email.addEventListener('input', () => {
        $stepOneEmail.value = $email.value;
        if ($summaryEmail.firstElementChild) {
            $summaryEmail.firstElementChild.textContent = $email.value;
        }
    });

    const $phone = $form.querySelector('#phone') as HTMLInputElement;
    const p = new phone.Phone($phone);

    const $name = $form.querySelector('#name') as HTMLInputElement;
    const $company = $form.querySelector('#company') as HTMLInputElement;

    const upload = document.getElementById('upload') as HTMLLabelElement;
    const u = new uploads.Uploader(upload);

    const $quantity = $form.querySelector('#quantity') as HTMLInputElement;
    const $minQty = $form.querySelector('#min-qty') as HTMLElement;
    $quantity.addEventListener('input', () => {
        switch (selectedLineItem) {
        case 'Challenge Coins':
            $minQty.textContent = '50';
            break;
        case 'Patches':
            $minQty.textContent = '100';
            break;
        case 'Lapel Pins':
            $minQty.textContent = '100';
            break;
        case 'Belt Buckles':
            $minQty.textContent = '50';
            break;
        case 'Charms':
            $minQty.textContent = '100';
            break;
        case 'Key Chains':
            $minQty.textContent = '100';
            break;
        case 'Lanyards':
            $minQty.textContent = '100';
            break;
        case 'Medals':
            $minQty.textContent = '50';
            break;
        case 'Ornaments':
            $minQty.textContent = '50';
            break;
        }
    });
    const $dateNeeded = $form.querySelector('#date') as HTMLInputElement;

    const $notes = $form.querySelector('#notes') as HTMLInputElement;
    const $project = $form.querySelector('#project') as HTMLInputElement;
    const $budget = $form.querySelector('#budget') as HTMLInputElement;
    const $promoInput = document.querySelector('#promo') as HTMLInputElement;
    const $promoCodeSuccess = document.querySelector('#promo-code-success') as HTMLElement;
    const $promoCodeTitle = document.querySelector('#promo-code-title') as HTMLElement;
    const $promoCodeDescription = document.querySelector('#promo-code-description') as HTMLElement;
    const promoInput = new promos.Input($promoInput, {
        error: () => {
            $promoCodeSuccess.classList.add('d-none');
        },
        success: p => {
            $promoCodeSuccess.classList.remove('d-none');
            $promoCodeTitle.textContent = p.name;
            $promoCodeDescription.textContent = p.description;
        },
        $email,
    });
    const $sms = $form.querySelector('#sms-opt-in') as HTMLInputElement;

    const submit = document.querySelector('#submit') as HTMLButtonElement;

    let selectedLineItem: string = '';
    let selectedType: string = '';
    let selectedSize: string = '';
    const selectedChildren: quoterequests.Child[] = [];
    const selectedExtras = new Set<string>();
    const namedExtras: Record<string, string> = {};
    let width: number | undefined;
    let height: number | undefined;

    $form.querySelectorAll('.prev').forEach($ => $.addEventListener('click', () => prev()));
    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();
        buttons.Start(submit);

        const extras: quoterequests.Extra[] = [];
        for (const e of Array.from(selectedExtras.values())) {
            extras.push({
                name: e,
            });
        }
        for (const k of Object.keys(namedExtras)) {
            extras.push({
                name: k,
                value: namedExtras[k],
            });
        }

        await promoInput.Check();

        if (!ReportValidity($form)) {
            buttons.Stop(submit);
            return false;
        }

        let usePatchesSize = false;
        if (width && height && selectedLineItem === 'Patches') {
            usePatchesSize = true;
        }

        void quoterequests.NewQuoteRequest({
            company: $company.value,
            email: $email.value,
            name: $name.value,
            phone: p,
            countryID: await GetCountryIDFromPhone(p),
            children: selectedChildren,
            lineItem: selectedLineItem,
            dateNeeded: String($dateNeeded.value),
            notes: $notes.value,
            project: $project.value,
            quantity: parseInt($quantity.value, 10),
            size: usePatchesSize ? undefined : selectedSize,
            width: usePatchesSize ? width : undefined,
            height: usePatchesSize ? height : undefined,
            type: selectedType,
            uploader: u,
            extras,
            budget: parseFloat($budget.value),
            promo: $promoInput.value,
            sms: $sms.checked,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String($name.value));
            dataLayer.push({
                'event': 'hugo-visual-quote-request-form-success',
                'userData': {
                    'email': sess?.email || $stepOneEmail.value,
                    'phone': sess?.phone || await p.Format(),
                    'firstName': sess?.firstName || firstName,
                    'lastName': sess?.lastName || lastName,
                },
                'transactionId': quoteRequest.id,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });
            location.href = `${Relref('/quote/received')}?ref=${encodeURIComponent(location.href)}`;
        }).catch(err => {
            if (object.IsObject(err) &&
                object.IsObject(err['response']) &&
                object.IsObject(err['response']['data']) &&
                object.HasKey(err['response']['data'], 'phone')) {
                const phoneObjectEle = $phone;
                phoneObjectEle.setCustomValidity('This phone number is incorrect');
                ReportValidity(phoneObjectEle);
                phoneObjectEle.addEventListener('input', () => {
                    phoneObjectEle.setCustomValidity('');
                });
            }
            buttons.Stop(submit);
        });
    });

    interface option {
        name: string; pluralName?: string; artwork: string; pricing?: string;
    }
    interface makeStepOpts {
        index: number;
        title: string;
        options: (option | string)[];
        $form?: HTMLFormElement;
        name: string;
        checkboxes?: boolean;
        summary?: () => string;
        click: (option?: option, checked?: boolean) => Promise<void> | void;
    }
    const makeStep = (opts: makeStepOpts) => {
        if ($steps.children.length > opts.index) {
            return;
        }

        const $step = template.Clone($stepTemplate).firstElementChild as HTMLElement;
        const $title = $step.querySelector('.title') as HTMLElement;
        $title.textContent = opts.title;

        if (opts.checkboxes) {
            const $next = $step.querySelector('.next')?.cloneNode(true) as HTMLElement;
            $next.classList.add('d-none');
            $next.classList.add('float-end');
            $title.before($next);
        }

        if (opts.index) {
            $step.querySelectorAll('.prev.d-none').forEach($ => {
                $.classList.remove('d-none');
                $.addEventListener('click', () => prev());
            });
        }

        if (opts.checkboxes) {
            $step.querySelectorAll('.next.d-none').forEach($ => {
                $.classList.remove('d-none');
                $.addEventListener('click', () => next());
                $.textContent = 'Skip';
            });
        }

        const $options = $step.querySelector('.options') as HTMLElement;

        for (const o of opts.options) {
            if (typeof o === 'string') {
                $options.appendChild(html.FromString(`<h4 class="w-100 mb-2">${o}</h4>`));
                continue;
            }

            const id = UUID();
            const $option = template.Clone($optionTemplate).firstElementChild as HTMLElement;
            const $input = $option.querySelector('input') as HTMLInputElement;
            $input.setAttribute('value', o.pluralName ?? '');
            $input.setAttribute('name', opts.name);
            $input.setAttribute('id', id);

            if (opts.checkboxes) {
                $input.setAttribute('type', 'checkbox');
            }

            const $label = $option.querySelector('label') as HTMLElement;
            $label.setAttribute('for', id);
            ($label.querySelector('p') as HTMLElement).innerText = o.pluralName || o.name;
            $label.querySelector('img')?.replaceWith(html.FromString(o.artwork in images ? images[o.artwork].ArtworkHTML(undefined, false) : '') || '');
            $options.appendChild($option);

            if (o.pricing) {
                ($label.querySelector('small') as HTMLElement).textContent = o.pricing;
            }

            $input.addEventListener('click', async () => {
                if (!opts.checkboxes) {
                    const $currentSummary = $summary.querySelectorAll('li')[currentStep];
                    $currentSummary.querySelector('small')?.remove();
                    $currentSummary.appendChild(html.FromString(`<small>${html.Escape(o.pluralName || o.name)}</small>`));
                    $steps.style.opacity = '.5';
                    $steps.style.pointerEvents = 'none';
                }

                await opts.click(o, $input.checked);

                if (!opts.checkboxes) {
                    $steps.style.opacity = '1';
                    $steps.style.pointerEvents = 'auto';
                }

                const $next = $step.querySelector('.next.d-none');
                $next?.classList.remove('d-none');
                $next?.addEventListener('click', () => next());

                if (!opts.checkboxes) {
                    next();
                } else {
                    $step.querySelectorAll('.next').forEach($btn => $btn.textContent = 'Next');
                }
            });
        }

        if (opts.$form) {
            $options.after(opts.$form);

            // remove the buttons if they were already in the form
            opts.$form.querySelector('.next')?.parentElement?.remove();

            const $next = $step.querySelector('.next');
            $next?.classList.remove('d-none');
            opts.$form.appendChild($next?.parentElement as HTMLElement);
            $step.querySelector('.prev')?.setAttribute('type', 'button');

            opts.$form.noValidate = true;
            opts.$form.addEventListener('submit', async e => {
                e.preventDefault();

                if (!ReportValidity(opts.$form as HTMLFormElement)) {
                    return;
                }

                await opts.click();

                if (opts.summary) {
                    const $currSummary = $summary.querySelectorAll('li')[currentStep];
                    $currSummary.querySelector('small')?.remove();
                    $currSummary.appendChild(html.FromString(`<small>${html.Escape(opts.summary())}</small>`));
                }

                next();
            });
        }

        $steps.appendChild($step);
    };

    const products = [
        {
            pluralName: 'Challenge Coins',
            name: 'Challenge Coin',
            artwork: 'Product/Challenge Coin',
        },
        {
            pluralName: 'Lapel Pins',
            name: 'Lapel Pin',
            artwork: 'Product/Lapel Pin',
        },
        {
            pluralName: 'Patches',
            name: 'Patch',
            artwork: 'Product/Patch',
        },
        {
            pluralName: 'Belt Buckles',
            name: 'Belt Buckle',
            artwork: 'Product/Belt Buckle',
        },
        {
            pluralName: 'Charms',
            name: 'Charm',
            artwork: 'Product/Charm',
        },
        {
            pluralName: 'Key Chains',
            name: 'Key Chain',
            artwork: 'Product/Key Chain',
        },
        {
            pluralName: 'Lanyards',
            name: 'Lanyard',
            artwork: 'Product/Lanyard',
        },
        {
            pluralName: 'Medals',
            name: 'Medal',
            artwork: 'Product/Medal',
        },
        {
            pluralName: 'Ornaments',
            name: 'Ornament',
            artwork: 'Product/Ornament',
        },
    ];

    // coins are already in the front by default
    // so we don't need to check for Signature Coins
    if (location.hostname.includes('signaturepins')) {
        products.sort((a, b) => {
            const isA = a.pluralName === 'Lapel Pins' ? 1 : 0;
            const isB = b.pluralName === 'Lapel Pins' ? 1 : 0;

            return isB - isA;
        });
        $form.classList.add('signature-pins-visual-quote');
    } else if (location.hostname.includes('signaturepatches')) {
        products.sort((a, b) => {
            const isA = a.pluralName === 'Patches' ? 1 : 0;
            const isB = b.pluralName === 'Patches' ? 1 : 0;

            return isB - isA;
        });
        $form.classList.add('signature-patches-visual-quote');
    } else if (location.hostname.includes('signaturelanyards')) {
        products.sort((a, b) => {
            const isA = a.pluralName === 'Lanyards' ? 1 : 0;
            const isB = b.pluralName === 'Lanyards' ? 1 : 0;

            return isB - isA;
        });
        $form.classList.add('signature-lanyards-visual-quote');
    } else {
        $form.classList.add('signature-coins-visual-quote');
    }

    $stepOneForm.addEventListener('submit', async e => {
        e.preventDefault();

        if (!$stepOneForm.checkValidity()) {
            return false;
        }

        await axios.post('/users/email', {
            'email': $stepOneEmail.value,
            'pageRequestID': await GetPageRequestID(),
            'tz': new Intl.DateTimeFormat().resolvedOptions().timeZone,
        }).then(async () => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'hugo-pre-form-email-submit',
                'userData': {
                    'email': sess?.email || $stepOneEmail.value,
                    'phone': sess?.phone,
                    'firstName': sess?.firstName,
                    'lastName': sess?.lastName,
                },
            });
        }).catch(err => HandleRequestError(err));
    });

    makeStep({
        index: 0,
        title: 'Please Enter Your Email',
        name: '',
        options: [],
        $form: $stepOneForm,
        click: () => {
            // dont need click
        },
        summary: () => $stepOneEmail.value,
    });
    makeStep({
        index: 1,
        title: 'What kind of product are you looking for?',
        name: 'lineItem',
        options: products,
        click: async (product?: option) => {
            if (!product) {
                throw Error('no product!');
            }

            selectedLineItem = product.pluralName ?? '';
            $quantity.dispatchEvent(new Event('input'));
            selectedChildren.length = 0;
            for (const e of Array.from(selectedExtras.values())) {
                selectedExtras.delete(e);
            }

            Array.from($steps.children).slice(2).forEach($ => $.remove());

            const children = await lineitems.GetChildren(product.pluralName ?? '');

            const updateSteps = (type?: option) => {
                Array.from($stepNumbers.querySelectorAll('div')).slice(!type ? 2 : 3).forEach($ => $.remove());
                Array.from($summary.querySelectorAll('li')).slice(!type ? 2 : 3).forEach($ => $.remove());

                // push "packages" steps to the end
                children.sort((a, b) => {
                    const isPackagingA = a.name === 'Packaging' ? 1 : 0;
                    const isPackagingB = b.name === 'Packaging' ? 1 : 0;

                    return isPackagingA - isPackagingB;
                });

                const steps: { name: string }[] = [];

                if (!type) {
                    steps.push({
                        name: 'Type',
                    });
                }

                if (product.pluralName === 'Patches') {
                    steps.push({
                        name: 'Shape',
                    });
                }

                steps.push({
                    name: 'Size',
                });

                let i = 0;
                for (const c of children) {
                    if (!c.options.length) {
                        continue;
                    }
                    if (!c.quoteForm) {
                        continue;
                    }

                    if (product.pluralName === 'Challenge Coins' && type?.name === 'Rush No Color') {
                        switch (c.name) {
                        case 'Plating':
                            c.name = 'Finish';
                            c.pluralName = 'Finishes';
                            break;
                        case 'Packaging':
                            continue;
                        }
                    }

                    switch (product.pluralName) {
                    case 'Challenge Coins':
                        switch (c.name) {
                        case 'Edge':
                        case 'Packaging':
                        case 'Plating':
                        case 'Finish':
                            break;
                        default:
                            continue;
                        }
                        break;
                    case 'Lapel Pins':
                        switch (c.name) {
                        case 'Plating':
                        case 'Attachment':
                        case 'Packaging':
                            break;
                        default:
                            continue;
                        }
                        break;
                    default:
                    // do nothing
                    }
                    children[i++] = c;

                    steps.push({
                        name: c.name,
                    });
                }
                children.length = i;

                switch (product.pluralName) {
                case 'Challenge Coins':
                    if (type?.name === 'Rush No Color') {
                        break;
                    }
                // falls through
                case 'Lapel Pins':
                case 'Patches':
                    steps.push({
                        name: 'Extras',
                    });
                    break;
                default:
                // do nothing
                }

                steps.push({
                    name: 'Contact Info',
                });

                for (const s of steps) {
                    $stepNumbers.appendChild(document.createElement('div'));
                    $summary.appendChild(html.FromString(`<li>${html.Escape(s.name)}</li>`));
                }
            };

            updateSteps();

            $stepNumbers.classList.remove('d-none');

            const options: option[] = [];
            const types = await lineitems.GetTypes(product.pluralName ?? '');
            for (const t of types) {
                if (!t.quoteForm) {
                    continue;
                }

                options.push({
                    name: t.name,
                    pluralName: t.pluralName,
                    artwork: `${product.name}/Type/${t.realName}`,
                });
            }
            if (product.pluralName === 'Challenge Coins') {
                options.push({
                    name: 'Rush No Color',
                    artwork: `${product.name}/Type/Rush No Color`,
                    pricing: '<10 days',
                });
            }

            makeStep({
                index: 2,
                title: `What type of ${product.name.toLowerCase()} would you like?`,
                name: 'type',
                options,
                click: async (type?: option) => {
                    if (!type) {
                        throw Error('no type!');
                    }

                    selectedType = type.pluralName || type.name;
                    if (selectedType === 'Rush No Color') {
                        selectedType = 'Made in USA - No Color Die Struck';
                    }

                    Array.from($steps.children).slice(3).forEach($ => $.remove());

                    updateSteps(type);

                    let stepIndexOffset = 3;
                    let $form: HTMLFormElement | undefined;
                    let summary;

                    const options: option[] = [];
                    if (product.pluralName === 'Challenge Coins' && type.name === 'Rush No Color') {
                        let name: string;
                        options.push(...[
                            {
                                name: name = GetReadableSize(1.5, 1.5, ''),
                                artwork: `${product.name}/Size/${name}`,
                            },
                            {
                                name: name = GetReadableSize(1.75, 1.75, ''),
                                artwork: `${product.name}/Size/${name}`,
                            },
                            {
                                name: name = GetReadableSize(2, 2, ''),
                                artwork: `${product.name}/Size/${name}`,
                            },
                        ]);
                    } else if (product.pluralName === 'Patches') {
                        makeStep({
                            index: 3,
                            title: 'What kind of shape is your patch?',
                            name: 'shape',
                            options: [
                                {
                                    name: 'Square/Rectangle',
                                    artwork: 'Patch/Shape/Rectangle',
                                },
                                {
                                    name: 'Circular',
                                    artwork: 'Patch/Shape/Circular',
                                },
                                {
                                    name: 'Custom',
                                    artwork: 'Patch/Shape/Custom',
                                },
                            ],
                            click: (shape?: option) => {
                                if (!shape) {
                                    throw Error('no shape!');
                                }

                                namedExtras['Shape'] = shape.name;
                            },
                        });

                        $form = template.Clone($patchSizeTemplate).firstElementChild as HTMLFormElement;
                        summary = () => {
                            width = parseFloat(String(document.querySelector<HTMLInputElement>('#width')?.value));
                            height = parseFloat(String(document.querySelector<HTMLInputElement>('#height')?.value));
                            return GetReadableSize(width, height, '');
                        };

                        stepIndexOffset = 4;
                    } else {
                        const sizes = await lineitems.GetSizes(product.pluralName ?? '', type.pluralName ?? '');
                        for (const s of sizes) {
                            if (!s.quoteForm) {
                                continue;
                            }

                            options.push({
                                name: s.name,
                                artwork: `${product.name}/Size/${s.realName}`,
                            });
                        }
                    }
                    makeStep({
                        index: stepIndexOffset,
                        title: 'What size are you looking for?',
                        name: 'size',
                        options,
                        $form,
                        summary,
                        click: async (size?: option) => {
                            if (size) {
                                selectedSize = size.name;
                            }

                            let i = stepIndexOffset + 1;
                            for (const c of children) {
                                if (!c.quoteForm) {
                                    continue;
                                }
                                if (!c.options.length) {
                                    continue;
                                }

                                const options: option[] = [];

                                if (product.pluralName === 'Challenge Coins' && type.name === 'Rush No Color' && c.name === 'Finish') {
                                    let name: string;
                                    options.push(...[
                                        {
                                            name: name = 'Antique Brass',
                                            artwork: `Rush No Color/Plating/${name}`,
                                            pricing: 'Most Popular',
                                        },
                                        {
                                            name: name = 'High Polished Brass',
                                            artwork: `Rush No Color/Plating/${name}`,
                                        },
                                        {
                                            name: name = 'Crushed Silver Cerakote',
                                            artwork: `Rush No Color/Plating/${name}`,
                                        },
                                        {
                                            name: name = 'Rose Gold Cerakote',
                                            artwork: `Rush No Color/Plating/${name}`,
                                        },
                                        {
                                            name: name = 'Titanium Cerakote',
                                            artwork: `Rush No Color/Plating/${name}`,
                                        },
                                        {
                                            name: name = 'Carbon Grey Cerakote',
                                            artwork: `Rush No Color/Plating/${name}`,
                                        },
                                        {
                                            name: name = 'Armor Black Cerakote',
                                            artwork: `Rush No Color/Plating/${name}`,
                                        },
                                        {
                                            name: name = 'FDE Cerakote',
                                            artwork: `Rush No Color/Plating/${name}`,
                                        },
                                    ]);
                                } else {
                                    const childOptions = await lineitems.GetOptions(product.pluralName ?? '', c.pluralName);
                                    for (const o of childOptions) {
                                        if (!o.quoteForm) {
                                            continue;
                                        }

                                        if (product.pluralName === 'Challenge Coins' && type.name === 'Rush No Color' && c.name === 'Edge') {
                                            switch (o.name) {
                                            case 'Rope':
                                            case 'Standard':
                                            case 'Spur':
                                                break;
                                            default:
                                                continue;
                                            }
                                        }
                                        const newOption: option = {
                                            name: o.name,
                                            pluralName: o.pluralName,
                                            artwork: `${product.name}/${c.realName}/${o.realName}`,
                                        };
                                        if (o.price.toNumber()) {
                                            newOption.pricing = `+$${o.price.toFixed(2)} per unit`;
                                        }
                                        options.push(newOption);
                                    }
                                }
                                const index = i++;
                                makeStep({
                                    index,
                                    title: `What ${c.name.toLowerCase()} are you looking for?`,
                                    name: `child.${c.name}`,
                                    options,
                                    click: (option?: option) => {
                                        if (!option) {
                                            throw Error('no option!');
                                        }

                                        const child: quoterequests.Child = {
                                            child: c.pluralName,
                                            option: option.pluralName || option.name,
                                        };
                                        if (index - 4 < selectedChildren.length) {
                                            selectedChildren[index - 4] = child;
                                        } else {
                                            selectedChildren.push(child);
                                        }
                                    },
                                });
                            }

                            let options: (option | string)[];

                            switch (product.pluralName) {
                            case 'Challenge Coins':
                                if (type.name === 'Rush No Color') {
                                    return;
                                }

                                options = [
                                    '<span class="text-primary">Mold</span> Upgrades',
                                    {
                                        name: '3D',
                                        artwork: 'Challenge Coin/Extra/3D',
                                        pricing: '$150.00 setup + $0.15 per side',
                                    },
                                    {
                                        name: 'Cut Out',
                                        pluralName: 'Cut Outs',
                                        artwork: 'Challenge Coin/Extra/Cut Out',
                                        pricing: '$0.15 per cut',
                                    },
                                    {
                                        name: 'Bottle Opener (External)',
                                        artwork: 'Challenge Coin/Extra/Bottle Opener (External)',
                                        pricing: 'No Additional Cost',
                                    },
                                    {
                                        name: 'Bottle Opener (Internal)',
                                        artwork: 'Challenge Coin/Extra/Bottle Opener (Internal)',
                                        pricing: '$50.00 setup + $0.15 per coin',
                                    },
                                    {
                                        name: 'Spinner (Internal)',
                                        artwork: 'Challenge Coin/Extra/Spinner (Internal)',
                                        pricing: 'Custom Pricing',
                                    },
                                    {
                                        name: 'Spinner (On Coin Face)',
                                        artwork: 'Challenge Coin/Extra/Spinner (On Coin Face)',
                                        pricing: 'Custom Pricing',
                                    },
                                    '<span class="text-primary">Paint</span> Upgrades',
                                    {
                                        name: 'Glow in the Dark',
                                        artwork: 'Challenge Coin/Extra/Glow in the Dark',
                                        pricing: '$0.20 per color',
                                    },
                                    {
                                        name: 'Glitter',
                                        artwork: 'Challenge Coin/Extra/Glitter',
                                        pricing: '$0.20 per color',
                                    },
                                    {
                                        name: 'Translucent',
                                        artwork: 'Challenge Coin/Extra/Translucent',
                                        pricing: '$0.20 per color',
                                    },
                                    '<span class="text-primary">Laser</span> Engraving',
                                    {
                                        name: 'Edge Engraving',
                                        artwork: 'Challenge Coin/Extra/Edge Engraving',
                                        pricing: '$0.65 per coin',
                                    },
                                    {
                                        name: 'Sequential Numbering',
                                        artwork: 'Challenge Coin/Extra/Sequential Numbering',
                                        pricing: '$0.25 per coin',
                                    },
                                ];
                                break;
                            case 'Lapel Pins':
                                options = [
                                    {
                                        name: 'Gemstone',
                                        artwork: 'Lapel Pin/Extra/Gemstone',
                                        pricing: '$0.25 per pin',
                                    },
                                    {
                                        name: 'Sequential Numbering',
                                        artwork: 'Lapel Pin/Extra/Sequential Numbering',
                                        pricing: '$0.25 per pin',
                                    },
                                    '<span class="text-primary">Mold</span> Upgrades',
                                    {
                                        name: '3D Mold',
                                        artwork: 'Lapel Pin/Extra/3D Mold',
                                        pricing: '$150.00 setup + $0.15 per pin',
                                    },
                                    {
                                        name: 'Cut Outs',
                                        artwork: 'Lapel Pin/Extra/Cut Outs',
                                        pricing: '$0.10 per cut (per pin)',
                                    },
                                    {
                                        name: 'Custom Backstamp',
                                        artwork: 'Lapel Pin/Extra/Custom Backstamp',
                                        pricing: 'Mold fee starts at $55',
                                    },
                                    '<span class="text-primary">Enamel</span> Upgrades',
                                    {
                                        name: 'Glow in the Dark',
                                        artwork: 'Lapel Pin/Extra/Glow in the Dark',
                                        pricing: '$0.25 per color (per pin)',
                                    },
                                    {
                                        name: 'Glitter',
                                        artwork: 'Lapel Pin/Extra/Glitter',
                                        pricing: '$0.25 per color (per pin)',
                                    },
                                ];
                                break;
                            case 'Patches':
                                options = [
                                    '<span class="text-primary">Thread</span> Upgrades<br /><span class="small description-info"> Please write <u>which colors you would like designed with metallic, glow in the dark or neon threads</u> in the <strong><u>product notes field</u></strong>. </span>',
                                    {
                                        name: 'Neon Thread',
                                        artwork: 'Patch/Extra/Neon Thread',
                                        pricing: '$0.10 per color',
                                    },
                                    {
                                        name: 'Metallic Gold',
                                        artwork: 'Patch/Extra/Metallic Gold',
                                        pricing: '+25% to patch price',
                                    },
                                    {
                                        name: 'Metallic Silver',
                                        artwork: 'Patch/Extra/Metallic Silver',
                                        pricing: '+25% to patch price',
                                    },
                                    {
                                        name: 'Glow in the Dark',
                                        artwork: 'Patch/Extra/Glow in the Dark',
                                        pricing: 'Starting at $0.50 per patch',
                                    },
                                    '<span class="text-primary">Other</span> Options',
                                    {
                                        name: 'Cut Outs',
                                        artwork: 'Patch/Extra/Cut Outs',
                                        pricing: '$0.10 per cut (per patch)',
                                    },
                                ];
                                break;
                            default:
                                return;
                            }

                            makeStep({
                                index: i,
                                title: 'Any upgrades you\'d like to add?',
                                name: 'extras',
                                options,
                                checkboxes: true,
                                click: (extra?: option, checked?: boolean) => {
                                    if (!extra) {
                                        throw Error('no extra!');
                                    }

                                    if (checked) {
                                        selectedExtras.add(extra.pluralName || extra.name);
                                    } else {
                                        selectedExtras.delete(extra.pluralName || extra.name);
                                    }
                                },
                            });
                        },
                    });
                },
            });
        },
    });

    showStep();

    document.querySelector('#quote-spinner')?.remove();
    document.querySelector('#quote-parent')?.classList.remove('d-none');
}